import React from 'react';
import OverWindow from '../../../Elements/OverWindow';
import ColButton from '../../../Elements/ColButton';
import Loading from '../../../Elements/loading';
import EvaluatorService from '../../../Services/EvaluatorService';
import TipaltiEvaluatorDataItem from './TipaltiEvaluatorDataItem';
import TabListTable from '../../../Elements/TabListTable';
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';
import ErrorMessage from '../../../Elements/ErrorMessage';

class ShowTipaltiEvaluatorDataWindow extends React.Component {
  static defaultProps = {
    evaluator: {},
    clickOnCancel: () => {
      alert('Missing function');
    },
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      tipaltiEvaluatorData: null,
    };
  }

  componentDidMount() {
    this.populateTipaltiEvaluatorData();
  }

  async populateTipaltiEvaluatorData() {
    EvaluatorService.GetTipaltiEvaluatorData(this.getTipaltiId())
      .then((result) => {
        const tempData = new TipaltiEvaluatorDataItem(result);
        this.setState({
          loading: false,
          tipaltiEvaluatorData: tempData,
        });
      })
      .catch(() => ErrorMessage.SetErrorMessage('STEDW47'));
  }

  renderButtons() {
    return (
      <ButtonFooterContainer>
        <ColButton
          text='Close'
          onClick={this.props.clickOnCancel}
        />
      </ButtonFooterContainer>
    );
  }

  renderInfo() {
    if (this.state.tipaltiEvaluatorData.ErrorMessage !== 'OK') {
      return (
        <div>
          <h4>Tipalti has sent the following message:</h4>
          <h1 className='text-center'>{this.state.tipaltiEvaluatorData.ErrorMessage}</h1>
        </div>
      );
    }
    let payableimg = this.state.tipaltiEvaluatorData.Payable === 'True' ? '/img/yes.png' : '/img/no.png';
    return (
      <div className='container'>
        <TabListTable
          caption={
            <span>
              Tipalti ID (GUID): {this.getTipaltiId()}{' '}
              <img
                src={payableimg}
                width='100'
                alt='pnp'
              />
            </span>
          }
          data={this.state.tipaltiEvaluatorData}
          moneyFields={TipaltiEvaluatorDataItem.MoneyFields}
          moneyFieldsSecondary={TipaltiEvaluatorDataItem.MoneyFieldsSecondary}
          dateFields={TipaltiEvaluatorDataItem.DateFields}
          currency={TipaltiEvaluatorDataItem.Currency()}
          currencySecondary={TipaltiEvaluatorDataItem.CurrencySecondary()}
          fieldsToShow={TipaltiEvaluatorDataItem.FieldsToShowInListTable}
          boolFields={TipaltiEvaluatorDataItem.BoolFields}
          selected={0}
        />
      </div>
    );
  }

  getTipaltiId() {
    if (this.state.tipaltiEvaluatorData?.Idap) {
      return this.state.tipaltiEvaluatorData.Idap;
    }
    return this.props.evaluator?.TipaltiId;
  }

  render() {
    return (
      <OverWindow
        clickOnCancel={this.props.clickOnCancel}
        title={`Tipalti Evaluator Data - ${this.props.evaluator.Name} (Tipalti ID: ${this.getTipaltiId()})`}
        closeOnClickOutside={false}
      >
        <div className=' p-1 m-1'>{this.state.loading ? <Loading /> : this.renderInfo()}</div>
      </OverWindow>
    );
  }
}

export default ShowTipaltiEvaluatorDataWindow;
